module.exports = __webpack_public_path__ + "img/odoo-for-inventory-min.5ca88800.png";